module.exports = "https://trybtryb-legacy.web.app/img/side-squares-special-desktop.8182cb52.svg";